// extracted by mini-css-extract-plugin
export default {"UserCard":"UserCard_UserCard__phd8I","profile":"UserCard_profile__JhpeT","question":"UserCard_question__9EDrH"};